import React from 'react'
import IncludeSideBar from '../../../Components/Sidebar/IncludeSideBar'


function LivePromotions() {
  return (
   <IncludeSideBar>
    <div>
        <p>
            Here we are displaying the ongoing propmotions
        </p>
    </div>
   </IncludeSideBar>
  )
}

export default LivePromotions